export default __webpack_public_path__ + "static/media/screenshot5.83248f01.jpg";